export const createAutoRefillOrderRequestDefault = '{\n' +
    '    "daysSupply": "",\n' +
    '    "drugId": "",\n' +
    '    "eventType": "DRUG_FILLABLE",\n' +
    '    "fulfillableProductAsin": "",\n' +
    '    "prescriptionId": "",\n' +
    '    "profileId": "",\n' +
    '    "drugAsin": false\n' +
    '}';

export interface ICreateAutoRefillOrderRequest {
    daysSupply: string,
    drugId: string,
    eventType: string,
    fulfillableProductAsin: string,
    prescriptionId: string,
    profileId: string,
    drugAsin?: boolean
}
